module.exports = __webpack_public_path__ + "img/mailsent.15bf3778.svg";